import { createCrudApi } from './crud';

export interface EvcpdProduct {
  id: number;
  productCode: string;
  name: string;
  sku: string | null;
  category: string;
  capacityKw: number | null;
  connectorType: string | null;
  unitPrice: number;
  gstPercent: number;
  hsnCode: string | null;
  inventoryItemId: number | null;
  status: string;
  createdAt: string;
}

export interface CreateProductInput {
  name: string;
  sku?: string;
  category?: string;
  capacityKw?: number | null;
  connectorType?: string;
  unitPrice?: number;
  gstPercent?: number;
  hsnCode?: string;
  inventoryItemId?: number | null;
  status?: string;
}

export const evcpdProductsApi = createCrudApi<EvcpdProduct, CreateProductInput>('evcpd-products');
